/**
 * One reading of a failed design request, for every caller that has to show it.
 *
 * fim-service puts the useful sentence in FastAPI's `detail` — the eligibility
 * reasons, the 409 that refuses a second job on one entry, the window a
 * synchronous route will not serve. Falling back to Axios's own message
 * ("Request failed with status code 422") throws all of that away.
 */
export const describeRequestError = (error: unknown): string => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof error.response === 'object' &&
    error.response !== null &&
    'data' in error.response
  ) {
    const data = error.response.data
    if (typeof data === 'object' && data !== null && 'detail' in data) {
      const detail = (data as { detail: unknown }).detail
      return typeof detail === 'string' ? detail : JSON.stringify(detail)
    }
  }
  return error instanceof Error ? error.message : String(error)
}
